// @ts-strict-ignore
import React, { useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'
import { formatThousands } from '../../utils/formatter'

interface InputProps {
  type: string
  value: number
  onChange?: Function
  name: string
  prefix?: string
  placeholder?: string
  suffix?: string
  format?: string
  error?: boolean
  buttonActions?: Record<string, string | number>
}

const Input: React.FC<InputProps> = React.forwardRef(
  (
    {
      type,
      value,
      step,
      onChange,
      name,
      prefix,
      placeholder,
      suffix,
      format,
      error = false,
      buttonActions,
    },
    ref,
  ) => {
    const formatString = (str: string) => {
      if (type === 'text' && format !== 'thousands') {
        return str
      }

      if (type === 'number' && step && step < 1 && step > -1) {
        const i = str.indexOf('.')
        if (i >= 0) {
          const lhs = str.substring(0, i).replace(/[^0-9]/g, '')
          const rhs = str.substring(i + 1).replace(/[^0-9]/g, '')
          return `${lhs}.${rhs}`
        }
      }

      const s = str.replace(/[^0-9]/g, '')
      return format === 'thousands' ? formatThousands(s) : s
    }
    const toInteger = (v) => {
      if (format === 'thousands') {
        const parsed = parseInt(v.replace(/[^0-9]/g, ''))
        return isNaN(parsed) ? 0 : parsed
      }

      if (type === 'number' && step && step < 1 && step > -1) {
        return parseFloat(v)
      }

      return type === 'number' ? parseInt(v) : v
    }

    const toString = useCallback(
      (v: number) => {
        const s = v.toString()
        return format === 'thousands' ? formatThousands(s) : s
      },
      [format],
    )

    const [valueString, setValueString] = useState(toString(value))

    useEffect(() => {
      setValueString(toString(value))
    }, [value, toString])

    const handleChange = (e) => {
      setValueString(formatString(e.target.value))

      {
        onChange &&
          onChange({
            ...e,
            target: {
              ...e.target,
              value: toInteger(e.target.value),
            },
          })
      }
    }

    return (
      <div className='Platinum-input-wrapper'>
        {prefix && (
          <span className='Platinum-input-prefix' data-input-prefix-selector-content>
            {prefix}
          </span>
        )}
        <input
          name={name}
          data-format={format}
          data-calculator-value={valueString}
          type={type}
          step={step}
          placeholder={placeholder}
          onChange={handleChange}
          value={valueString}
          className={classNames('Platinum-input', {
            'Platinum-input-prefix-space': prefix,
            'Platinum-input-suffix-space': suffix,
            'Platinum-input__error': error,
          })}
          {...buttonActions}
          ref={ref}
        />
        {suffix && <span className='Platinum-input-suffix'>{suffix}</span>}
      </div>
    )
  },
)

export default Input
